"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerPathGroup = exports.apiPathGroup = exports.packageGroup = exports.subjectName = void 0;
exports.subjectName = 'Resource Owner';
exports.packageGroup = 'resource-owner';
exports.apiPathGroup = 'resource-owners';
exports.routerPathGroup = 'resource-owner';
